import { Toaster as SonnerToaster, toast } from "sonner";

/**
 * TINA Toast — built on `sonner`. Wrap the app once with <Toaster />,
 * call `toast.success()`, `toast.error()`, `toast.info()` etc. anywhere.
 *
 * Tone mapping matches MASTER.md semantic colors. Toasts are top-right,
 * persist 5 seconds, dismissible via click.
 *
 * Usage:
 *   import { toast } from "@/components/ui/toast";
 *   toast.success(t("payroll.saved"));
 *   toast.error(t("errors.network"), { description: t("errors.retry_hint") });
 */
export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      duration={5000}
      closeButton
      richColors
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-surface group-[.toaster]:text-slate-900 group-[.toaster]:border-slate-200 group-[.toaster]:shadow-modal group-[.toaster]:rounded-lg",
          description: "group-[.toast]:text-slate-600",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-fg group-[.toast]:rounded-md",
          cancelButton:
            "group-[.toast]:bg-surface-alt group-[.toast]:text-slate-700 group-[.toast]:rounded-md",
          success:
            "group-[.toaster]:!border-success/30 group-[.toaster]:!bg-success-subtle group-[.toaster]:!text-success",
          error:
            "group-[.toaster]:!border-danger/30 group-[.toaster]:!bg-danger-subtle group-[.toaster]:!text-danger",
          warning:
            "group-[.toaster]:!border-warning/30 group-[.toaster]:!bg-warning-subtle group-[.toaster]:!text-warning",
          info: "group-[.toaster]:!border-info/30 group-[.toaster]:!bg-info-subtle group-[.toaster]:!text-info",
        },
      }}
    />
  );
}

export { toast };
